module.exports = __webpack_public_path__ + "static/UMG-logo-ee3cbdd1f1c51e9c1f7e0498f4982f0c.svg";